import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Magazine } from './pages/Magazine';
import { Archive } from './pages/Archive';
import { About } from './pages/About';
import { Team } from './pages/Team';
import { Subscription } from './pages/Subscription';
import { Contact } from './pages/Contact';
import { EditorialPolicy } from './pages/EditorialPolicy';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Terms } from './pages/Terms';
import { CurrentIssuePage } from './pages/CurrentIssuePage';
import { JanFeb2026IssuePage } from './pages/JanFeb2026IssuePage';
import { ScrollToTop } from './components/ScrollToTop';
export type Language = 'pashto' | 'english';
export function App() {
  const [language, setLanguage] = useState<Language>('pashto');
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'pashto' ? 'english' : 'pashto');
  };
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-white text-pasoon-dark font-sans selection:bg-pasoon-red/20 selection:text-pasoon-red flex flex-col" dir={language === 'pashto' ? 'rtl' : 'ltr'} data-id="element-2">
        <Navbar language={language} toggleLanguage={toggleLanguage} data-id="element-3" />
        <main className="flex-1" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home language={language} data-id="element-7" />} data-id="element-6" />
            <Route path="/magazine" element={<Magazine language={language} data-id="element-9" />} data-id="element-8" />
            <Route path="/current-issue" element={<CurrentIssuePage language={language} data-id="element-11" />} data-id="element-10" />
            <Route path="/jan-feb-2026" element={<JanFeb2026IssuePage language={language} data-id="element-13" />} data-id="element-12" />
            <Route path="/archive" element={<Archive language={language} data-id="element-15" />} data-id="element-14" />
            <Route path="/about" element={<About language={language} data-id="element-17" />} data-id="element-16" />
            <Route path="/team" element={<Team language={language} data-id="element-19" />} data-id="element-18" />
            <Route path="/subscription" element={<Subscription language={language} data-id="element-21" />} data-id="element-20" />
            <Route path="/contact" element={<Contact language={language} data-id="element-23" />} data-id="element-22" />
            <Route path="/editorial-policy" element={<EditorialPolicy language={language} data-id="element-25" />} data-id="element-24" />
            <Route path="/privacy-policy" element={<PrivacyPolicy language={language} data-id="element-27" />} data-id="element-26" />
            <Route path="/terms" element={<Terms language={language} data-id="element-29" />} data-id="element-28" />
          </Routes>
        </main>
        <Footer language={language} data-id="element-30" />
      </div>
    </BrowserRouter>;
}